import { Route, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { StorageService } from '../service/shared/storage.service';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(private router: Router, private storage: StorageService, private jwtHelper: JwtHelperService) { }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = this.storage.getToken();

    if (request.url.includes('/login')) {
      return next.handle(request);
    }

    if (!this.jwtHelper.isTokenExpired(token)) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          token: `${token}`,
        },
      });

      return next.handle(request)
        .pipe(
          catchError((error) => {
            // Lida com erros, por exemplo, token expirado, aqui
            if (error.status === 401) {
              this.storage.clean();
              this.router.navigate(['/login']);
            }
            return throwError(error);
          })
        );
    } else {
      this.storage.clean();
      this.router.navigate(['/login']);
      return throwError('Token is not valid or expired');
    }
  }
}
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
];
